import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("",{ moduleName: "cio/components/action-composer/types/email/index.hbs" })